import type { Struct } from '@subaio/validation'

export const inferFieldType = (struct: Struct<any, any> | undefined) => {
	if (!struct) return undefined
	const structType = struct.type.toLowerCase()
	if (structType.includes('phonenumber')) return 'tel'
	if (structType.includes('number')) return 'number'
	if (structType.includes('password')) return 'password'
	if (structType.includes('email')) return 'email'

	return undefined
}
